import { render, staticRenderFns } from "./OTableMessagesComp.vue?vue&type=template&id=e0f72954&"
import script from "./OTableMessagesComp.vue?vue&type=script&lang=js&"
export * from "./OTableMessagesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports